import {BaseWidget} from "./BaseWidget";
import {fetchSignatureLineApplied, isSignatureField, nextGUIDId} from "../login/ClientCache";
import {ajaxJSONWithoutWait} from "../common/NamaCommon";
import * as urls from "../constants/NamaURLS";
import * as GUIDevMode from "../constants/GUIDevMode";

let caller;

export class AttachmentWidget extends BaseWidget {
    createElement(style) {
        return $(`<div class="nama-upload w-100"><div class="w-100" id="${this.elementId}wrapper">${this._renderInput()}</div></div> `);
    }

    _renderInput() {
        return `<input type="file" id="${this.elementId}" name="fileId"></span>`;
    }

    afterAttach() {
        super.afterAttach();
        this.initWidget();
    }

    _onRemove(e) {
        let that = this;
        /**
         *
         * @type {namaTypes.DTOLargeData}
         */
        let data = $.extend({}, that._largeData || {});
        if (!data.attachmentInfo)
            data.attachmentInfo = {};
        data.attachmentInfo.removed = true;
        data.attachmentInfo.fileName = e.files[0].name;
        that._largeData = data;
        that.onEdit(data);
    }

    setValueInElement(value) {
        let that = this;
        that._largeData = value || {};
        that._resetWidget();
        let files = that._addFilesIfFounded(value);
        that.initWidget(files);
    }

    _addFilesIfFounded(value) {
        let files = [];
        if (value && value.attachmentInfo && value.attachmentInfo.fileName) {
            let name = value.attachmentInfo.fileName;
            let extension = name.substring(name.indexOf('.'));
            let fileId = value.attachmentInfo.fileId
            let file = {name: name, size: value.dataLength, extension: extension, fileId: fileId};
            files.push(file);
        }
        return files;
    }

    _resetWidget() {
        let that = this;
        let kendoUpload = that._kendoUpload();
        if (kendoUpload) {
            kendoUpload.destroy();
            let $wrapper = $('#' + that.elementId + 'wrapper');
            $wrapper.html(that._renderInput());
        }
    }

    initWidget(files) {
        let that = this;
        that.eSignature = false;
        /**
         *
         * @type {kendo.ui.UploadOptions}
         */
        let options = {
            async: {
                saveUrl: "upload?" + that._calcFileIdParam(),
                removeUrl: "upload?del=true" + that._calcFileIdParam(),
                autoUpload: true
            },
            remove: (e) => that._onRemove(e),
            success: (e) => that._onSuccess(e),
            cancel: (e) => that._onCancel(e),
            files: files,
            multiple: false,
            template: (e) => that._prepareTemplate(e),
        };
        that.findElement().on("click", (e) => {
            if (that.eSignature) {
                caller = that;
                let info = fetchSignatureLineApplied(that.owner.entityType, that.id);
                let height = info.height || 500;
                let width = info.width || 500;
                let params = "";
                if (info.lineWidth)
                    params = "lineWidth=" + info.lineWidth + "&";
                if (info.imageUrl)
                    params = params + "imgId=" + info.imageUrl;
                let page = "e-sig/index.html?";
                let windowHeight = height;
                let windowWidth = width;
                if (info.epadInk) {
                    page = "e-sig/epadink.html?";
                    windowHeight += 200;
                    windowWidth += 200;
                }
                window.open(page + params, "esignature", "height=" + windowHeight + ",width=" + windowWidth);
            } else
                that.find(".k-upload-files").css({display: ""});
        })
        that.findElement().kendoUpload(options);
        that._changeView();
    }

    _changeView() {
        let that = this;
        let wrapper = that.find("#" + that.elementId + "wrapper");
        let linkEle = wrapper.find("a");
        let href = that._calcLinkHREF();
        if (href) {
            linkEle.on("mouseover", (e) => {
                if (!that._largeData || !that._largeData.attachmentInfo)
                    return;
                previewAttachment(that.findElement(), that._largeData.attachmentInfo.fileId, that.owner.entityType, that.owner.id, that._largeData.attachmentInfo.fileName);
            });
            linkEle.on("mouseout", (e) => {
                previewAttachmentMouseOut(that.findElement());
            });
        } else {
            linkEle.removeAttr("onmouseover");
            linkEle.removeAttr("onmouseout");
        }
        let theUploadButtons = wrapper.find(".k-button.k-upload-button");
        let attachSpan = theUploadButtons.find("span");
        let dropZoneHint = wrapper.find(".k-dropzone-hint");
        dropZoneHint.css("display", "none");
        that.eSignature = isSignatureField(that.owner.entityType, that.id);
        attachSpan.html("");
        if (that.eSignature) {
            attachSpan.addClass("k-icon");
            attachSpan.addClass("k-i-track-changes-enable");
            attachSpan.append("<span>Assign</span>");
        } else {
            attachSpan.addClass("k-icon");
            attachSpan.addClass("k-i-clip");
            attachSpan.append("<span>Attach</span>");
        }
        theUploadButtons.css({borderTop: "0px", borderBottom: "0px", borderLeft: "0px", borderRight: "0px"});
        wrapper.find(".k-dropzone").find("li").remove();
        wrapper.find("ul>li").insertBefore(dropZoneHint).css({display: "inline-block", whiteSpace: 'normal'})
        wrapper.find(".k-dropzone").css({paddingTop: "0px", paddingBottom: "0px", paddingLeft: "0px"})
        wrapper.find(".k-upload-files").css({display: "none"});
    }

    _calcFileIdParam() {
        let id = this._safeAttachmentInfo().fileId;
        if (id)
            return "fileId=" + id;
        else
            return "";
    }

    setEnabled(enabled) {
        super.setEnabled(enabled);
        let kendoUploadWidget = this.findElement().data("kendoUpload");
        kendoUploadWidget.enable(enabled);
    }

    /**
     *
     * @return {namaTypes.DTOFileAttachmentInfo}
     * @private
     */
    _safeAttachmentInfo() {
        if (!this._largeData || !this._largeData.attachmentInfo)
            return {};
        return this._largeData.attachmentInfo;
    }

    /**
     *
     * @private
     * @returns {kendo.ui.Upload}
     */
    _kendoUpload() {
        return this.findElement().data("kendoUpload")
    }

    readValueFromElement() {
        return this._largeData;
    }

    _prepareTemplate(e) {
        let that = this;
        return `
<span class='k-progress'/>
<a class="pointer-events-all" href='${that._calcLinkHREF()}' id="${that.elementId}link">${e.name}</a>
<span class='k-file-size' style="display: inline">${Math.round(e.size / 1024)} KB</span>
<button type='button' id="${that.elementId}removebtn" class='k-upload-action uploadRemoveBtn'></button>`;
    }

    _calcLinkHREF() {
        let that = this;
        if (!that._safeAttachmentInfo().fileId)
            return "";
        return `${GUIDevMode.APP_URL}file.download?fileID=${that._safeAttachmentInfo().fileId}&entitytype=${that.owner.entityType}&ischanged=${that._isChanged()}`;
    }

    _isChanged() {
        return this._safeAttachmentInfo().updated;
    }

    shouldAddBlurHandler() {
        return false;
    }

    /**
     *
     * @param {kendo.ui.UploadSuccessEvent} e
     * @private
     */
    _onSuccess(e) {
        let that = this;
        /**
         *
         * @type {namaTypes.DTOLargeData}
         */
        let data = $.extend({}, that._largeData || {});
        if (!data.attachmentInfo)
            data.attachmentInfo = {};
        if (data.attachmentInfo.removed) {
            that._largeData = null;
        } else {
            data.attachmentInfo.updated = true;
            data.attachmentInfo.fileName = e.files[0].name;
            data.attachmentInfo.removed = false;
            data.attachmentInfo.fileId = e.response.fileId;
            that._largeData = data;
        }
        that.onEdit(that._largeData);
        let href = that._calcLinkHREF();
        let link = that.find("#" + that.elementId + "link");
        if (href) {
            link.prop("href", href);
        } else {
            link.removeProp("href");
        }
        that.find(".k-upload-files").css({display: "none"});
        that._changeView();
    }

    _onCancel(e) {
        this.find(".k-upload-files").css({display: "none"});
    }
}

export function calcAttachmentHREF(widget) {
    if (!widget || !widget.attachmentInfo)
        return ``;
    if (!widget.attachmentInfo.fileId)
        return ``;
    return `${GUIDevMode.APP_URL}file.download?fileID=${widget.attachmentInfo.fileId}&ischanged=${widget.attachmentInfo.updated}`;
}

export function uploadData(fileId) {
    let req = {
        fileName: "signature.png",
        fileId: fileId,
        dataURL: window.eSignataureDataURL
    };
    ajaxJSONWithoutWait(urls.UploadFileByDataURL, req, (result) => {
            let value = caller._largeData;
            if (!value)
                value = {};
            if (!value.attachmentInfo)
                value.attachmentInfo = {};
            value.attachmentInfo.fileId = fileId;
            value.attachmentInfo.fileName = "signature.png";
            value.attachmentInfo.updated = true;
            caller.setValue(value);
            caller = null;
        }
    );
}

window.onESignatureOK = function () {
    let fileId = "";
    if (caller._largeData)
        fileId = caller._largeData.attachmentInfo.fileId;
    if (!fileId) {
        nextGUIDId().then((value) => {
            uploadData(value);
        })
    } else {
        uploadData(fileId);
    }
}

window.onESignatureCancel = function () {
    caller = null;
}

